import moment from "moment";
export default function() {
    return {
        items: {
            data: [],
            columns: [
                { name: 'CUSTOMER', align: 'left', label: "CUSTOMER", field: row =>row.company?.admin_title,  },
                { name: 'COACHING TRACK', align: 'left', label: "COACHING TRACK", field: row =>row.slot_name,  },
                { name: 'START DATE', align: 'left', label: "START DATE", field: row =>moment(row.start_date).format("MMM Do YYYY"),  },
                { name: 'START TIME', align: 'left', label: "START TIME", field: row =>moment(row.start_date).format('LT'),  },
                { name: 'STATUS', align: 'left', label: "STATUS", field: row =>row.status,  },
                { name: 'EI COACH CHECKLIST', align: 'left', label: "EI COACH CHECKLIST", field: row =>'To be developed',  },
                { name: 'GET TO KNOW YOUR RESPONSES', align: 'left', label: "GET TO KNOW YOUR RESPONSES", field: row => 'To be developed',  },
                { name: "actions", align: "left", label: "IMPACT SURVEY RESULTS" },

            ],
            pagination: {
                sortBy: '',
                descending: false,
                page: 1,
                rowsPerPage: 10,
                totalRecords: 0
            },
            filter: {
                search: "",
                customers: [],
                status: '',
                dateRange: {
                    startDate: "",
                    endDate: "",
                  },
            },
            lastUpdated: '',
        },
        status: {
            active_tracks: 0,
            completed_tracks: 0,
            upcoming_tracks: 0,
        },
    }
}
